var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioPurpleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13209_5947)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#6FA0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7273 14.3333V20.6667C23.7273 21.1045 23.3615 21.4583 22.9091 21.4583C22.4566 21.4583 22.0909 21.1045 22.0909 20.6667V14.3333C22.0909 13.8955 22.4566 13.5417 22.9091 13.5417C23.3615 13.5417 23.7273 13.8955 23.7273 14.3333ZM19.6364 8C19.1839 8 18.8182 8.35388 18.8182 8.79167V26.2083C18.8182 26.6461 19.1839 27 19.6364 27C20.0888 27 20.4545 26.6461 20.4545 26.2083V8.79167C20.4545 8.35388 20.0888 8 19.6364 8ZM26.1818 11.1667C25.7294 11.1667 25.3636 11.5205 25.3636 11.9583V23.0417C25.3636 23.4795 25.7294 23.8333 26.1818 23.8333C26.6343 23.8333 27 23.4795 27 23.0417V11.9583C27 11.5205 26.6343 11.1667 26.1818 11.1667ZM16.3636 11.1667C15.9112 11.1667 15.5455 11.5205 15.5455 11.9583V23.0417C15.5455 23.4795 15.9112 23.8333 16.3636 23.8333C16.8161 23.8333 17.1818 23.4795 17.1818 23.0417V11.9583C17.1818 11.5205 16.8161 11.1667 16.3636 11.1667ZM13.0909 13.5417C12.6385 13.5417 12.2727 13.8955 12.2727 14.3333V20.6667C12.2727 21.1045 12.6385 21.4583 13.0909 21.4583C13.5434 21.4583 13.9091 21.1045 13.9091 20.6667V14.3333C13.9091 13.8955 13.5434 13.5417 13.0909 13.5417ZM9.81818 15.125C9.36573 15.125 9 15.4789 9 15.9167V19.0833C9 19.5211 9.36573 19.875 9.81818 19.875C10.2706 19.875 10.6364 19.5211 10.6364 19.0833V15.9167C10.6364 15.4789 10.2706 15.125 9.81818 15.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13209_5947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPurpleBg);
export default __webpack_public_path__ + "static/media/audio-purple-bg.85e24dee8b36bc550bb0942a81eb2d52.svg";
export { ForwardRef as ReactComponent };